export default function TextField({setSource, placeholder, secret=false}) {
    return (
        <input type={secret ? 'password' : 'text'} className={'w-full p-3 border rounded-xl'} placeholder={placeholder} onInput={(e) => setSource(e.target.value)} >

        </input>
    )
}